export default function Features() {
  const features = [
    {
      icon: 'ri-shield-check-line',
      title: '安心の10年保証',
      description: 'インプラント本体に10年間の長期保証を提供。万が一の場合も安心してご利用いただけます。',
      image: 'https://public.readdy.ai/ai/img_res/cab920a53ff58f982456a5bac0c7bca0.jpg'
    },
    {
      icon: 'ri-microscope-line',
      title: '最新の3D-CT診断',
      description: '高精度な3D-CTスキャンにより、骨の状態や神経の位置を正確に把握し、安全な治療を実現します。',
      image: 'https://static.readdy.ai/image/4d1e24136ef2955fabe2fc9c76951eeb/107309ef44ee9543fbc05dd5614d9d00.jpeg'
    },
    {
      icon: 'ri-award-line',
      title: '豊富な実績と経験\n難症例にも対応可能',
      description: 'アメリカNO1シェアのインプラントを使用。品質✖️術者であらゆるケースに対応。',
      image: 'https://static.readdy.ai/image/4d1e24136ef2955fabe2fc9c76951eeb/924c56bed61d08e2cb4a3d45783748c8.png'
    }
  ];

  return (
    <section id="features" className="py-24 bg-gradient-to-b from-white via-amber-50/30 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-20">
          <div className="inline-block mb-6">
            <span className="text-sm font-bold text-amber-500 tracking-widest uppercase">Why Choose Us</span>
          </div>
          <h2 className="text-5xl lg:text-6xl font-bold mb-6 bg-gradient-to-r from-slate-900 via-slate-800 to-slate-900 bg-clip-text text-transparent" style={{ fontFamily: '"Noto Serif JP", serif', letterSpacing: '0.02em' }}>
            選ばれる理由
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-amber-400 to-yellow-500 mx-auto"></div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div key={index} className="group bg-white/80 backdrop-blur-sm rounded-3xl p-8 shadow-xl hover:shadow-2xl transition-all duration-500 border border-amber-100 hover:border-amber-300 transform hover:-translate-y-2">
              <div className="flex justify-center mb-6">
                <div className="w-20 h-20 bg-gradient-to-br from-amber-400 to-yellow-500 rounded-full flex items-center justify-center shadow-lg">
                  <i className={`${feature.icon} text-slate-900 text-3xl`}></i>
                </div>
              </div>
              
              {feature.image && (
                <div className="mb-6 overflow-hidden rounded-2xl shadow-lg">
                  <img 
                    src={feature.image} 
                    alt={feature.title} 
                    className="w-full h-48 object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
              )}
              
              <div className="space-y-4">
                <h3 className="text-xl font-bold text-slate-900 group-hover:text-amber-600 transition-colors duration-300 whitespace-pre-line">
                  {feature.title}
                </h3>
                <p className="text-slate-600 leading-relaxed">
                  {feature.description}
                </p>
                <div className="w-12 h-1 bg-gradient-to-r from-amber-400 to-yellow-500 rounded-full group-hover:w-20 transition-all duration-300"></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
